import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'BaseDataService',
    controller: 'MonitorPermission'
};

const methods = [
    'UpdateItemList',
    'GetMonitorPermissionEquipmentById',
    'DelItem',
    'GetPageContentByConditions'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const MonitorPermissionApi = ZJApi.defineNewApi('MonitorPermissionApi', factory);

export default MonitorPermissionApi;